export default __webpack_public_path__ + "static/media/SackTrolley1.5f5eebf5.jpg";